@if (customer) {
<div class="container">
  <br>
  <div class="row">
    <div class="col">
      @if (comment) {
      <h4>CREATE A NEW NOTE</h4>
      }
      @if (!comment) {
      <h4>NOTES</h4>
      }
    </div>
  </div>
  <br>
  @if (comment) {
  <form id="customerCommentForm" #customerCommentForm="ngForm">
    <div class="row">
      <div class="col-sm-12 col-lg-6">
        <h6>Note</h6>
        <textarea pInputTextarea name="comment" [(ngModel)]="comment.comment" required></textarea>
      </div>
      <div class="col-sm-12 col-lg-2">
        <h6>Category</h6>
        <ng-select class="custom" [items]="stages" placeholder="Select a Category" name="stage" bindLabel="commentStage"
          [selectOnTab]="true" [(ngModel)]="comment.customerCommentStage" required>
        </ng-select>
      </div>
      <div class="col-sm-12 col-lg-2">
        <h6>Quote/Work Order #</h6>
        <input pInputText name="quoteNumber" [(ngModel)]="comment.quoteNumber" />
      </div>
      <div class="col-sm-12 col-lg-2">
        <h6>Company Wide Note?</h6>
        <p-checkbox binary="true" name="companyWide" [(ngModel)]="comment.companyWide">
        </p-checkbox>
        <div style="font-style: italic;">By checking the box, this note will be displayed to internal employees when
          viewing/creating quotes and work orders. Notes will never be visible to customers.</div>
      </div>
    </div>
    <div class="p-grid">
      <div class="col-sm-12 columnPadding">
        @if (customerCommentForm.invalid && customerCommentForm.submitted) {
        <div class="alert alert-danger" role="alert">
          There are errors on this page. Please correct the errors and resubmit.
        </div>
        }
      </div>
      <div class="col-sm-12">
        @if (!comment.id) {
        <p-button type="submit" (click)="saveComment(customerCommentForm)" severity="success" label="Submit">
        </p-button>
        }
        @if (comment.id) {
        <p-button type="submit" (click)="saveComment(customerCommentForm)" severity="success" label="Update">
        </p-button>
        }
      </div>
    </div>
  </form>
  }
  <div class="col-sm-12 col-sm-nopad">
    <p-table showGridlines stripedRows responsiveLayout="stack" [columns]="cols" [value]="allComments"
      [paginator]="true" [rows]="10" #notesTable sortField="companyWide" [sortOrder]="-1" [lazy]="false">
      <ng-template #caption>
        <div style="text-align: right">
          <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
          <input type="text" pInputText size="50" placeholder="Search..."
            (input)="notesTable.filterGlobal($event.target.value, 'contains')" style="width:auto">
        </div>
      </ng-template>
      <ng-template #header let-columns>
        <tr>
          @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [style.width]="col.width">
            {{col.header}}
            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
            </p-sortIcon>
          </th>
          }
          <th [style.width]="'10%'"><!-- for the buttons --></th>
        </tr>
      </ng-template>
      <ng-template #body let-eachComment let-columns="columns" let-rowIndex="rowIndex">
        <tr>
          <td><span class="p-column-title">{{columns[0].header}}</span>{{eachComment.lastEditedDate | date: 'short'}}
          </td>
          <td><span class="p-column-title">{{columns[1].header}}</span>{{eachComment.companyWide ? 'Yes': 'No'}}</td>
          <td><span class="p-column-title">{{columns[2].header}}</span>{{eachComment.customerCommentStage.commentStage}}
          </td>
          <td><span class="p-column-title">{{columns[3].header}}</span><span class="showLineBreaks">{{eachComment.comment}}</span></td>
          <td><span class="p-column-title">{{columns[4].header}}</span>{{eachComment.quoteNumber ?
            eachComment.quoteNumber : '--'}}</td>
          <td><span class="p-column-title">{{columns[5].header}}</span>{{eachComment.employee ?
            eachComment.employee.fullName : 'Customer'}}</td>
          <td><span class="p-column-title">{{columns[6].header}}</span>{{eachComment.dateCreated | date: 'short'}}</td>
          <td>
            <p-button type="button" icon="pi pi-pencil" (click)="editComment(eachComment)" [disabled]="!canEditComment"
              severity="info">
            </p-button>
            <p-button [disabled]="!canDeleteComment" type="button" icon="pi pi-trash"
              (click)="deleteComment(eachComment)" severity="danger">
            </p-button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="col-sm-12"></div>
</div>
}